/*
 * SelectAccount Messages
 *
 * This contains all the text for the SelectAccount component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.SelectAccount';

export default defineMessages({
  footer: {
    id: `${scope}.footer`,
    defaultMessage: 'Ergotest Innovation. All rights reserved 2021',
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Select Account',
  },
  subtitle: {
    id: `${scope}.subtitle`,
    defaultMessage: 'And manage your test results!',
  },
  createNewSpace: {
    id: `${scope}.createNewSpace`,
    defaultMessage: 'Create New Space',
  },
  myPersonalAccount: {
    id: `${scope}.myPersonalAccount`,
    defaultMessage: 'My personal account',
  },
  addSpace: {
    id: `${scope}.addSpace`,
    defaultMessage: 'Add space',
  },
  upgradeSpace: {
    id: `${scope}.upgradeSpace`,
    defaultMessage: 'There can be only one space with a basic subscription. Please upgrade your space subscription to add a new space.',
  }
});
